import React from "react";
import PropTypes from "prop-types";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import { Modal } from "../../shared/Modal/Modal";
import { Button } from "../../shared/Button/Button";
import classes from "./ModalClientFired.module.scss";

export function ModalClientFired({ isOpen, onClose, onSuccess }) {
  const { tCommon } = useAppTranslation.Common();
  const { tClients } = useAppTranslation.Clients();

  return (
    <Modal
      footerNoBorder
      isOpen={isOpen}
      onClose={onClose}
      shouldCloseOnOverlayClick={false}
      header={<Modal.Title>{tClients("firedProfile.title")}</Modal.Title>}
      footer={
        <div className={classes.footer}>
          <Button onClick={onClose}>{tCommon("label.cancel")}</Button>
          <Button variant="outlined" onClick={onSuccess}>
            {tClients("firedProfile.ignore")}
          </Button>
        </div>
      }
    >
      {tClients("firedProfile.content")}
    </Modal>
  );
}

ModalClientFired.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
